import { createSlice } from '@reduxjs/toolkit';

import type { TipoPrazo, TiposPrazoState } from '../types/tipoPrazoTypes';

import {
  alternarStatusTipoPrazo,
  atualizarTipoPrazo,
  criarTipoPrazo,
  listarTiposPrazo,
} from './actions';

const initialState: TiposPrazoState = {
  tiposPrazo: [],
  isLoading: false,
  isSaving: false,
  error: null,
};

const upsert = (state: TiposPrazoState, tipo: TipoPrazo) => {
  const index = state.tiposPrazo.findIndex((item) => item.id === tipo.id);
  if (index !== -1) {
    state.tiposPrazo[index] = tipo;
  } else {
    state.tiposPrazo.push(tipo);
  }
};

const tiposPrazoSlice = createSlice({
  name: 'tiposPrazo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // `error` é exclusivo do carregamento da lista; erros de criar/atualizar/alternar
    // status chegam ao usuário via unwrap + toast nos componentes.
    builder
      .addCase(listarTiposPrazo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarTiposPrazo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tiposPrazo = action.payload;
      })
      .addCase(listarTiposPrazo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(criarTipoPrazo.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(criarTipoPrazo.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(criarTipoPrazo.rejected, (state) => {
        state.isSaving = false;
      })

      .addCase(atualizarTipoPrazo.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(atualizarTipoPrazo.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(atualizarTipoPrazo.rejected, (state) => {
        state.isSaving = false;
      })

      .addCase(alternarStatusTipoPrazo.fulfilled, (state, action) => {
        upsert(state, action.payload);
      });
  },
});

export default tiposPrazoSlice.reducer;
